var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreditCardIconSmall = function SvgCreditCardIconSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    x: 0.5,
    y: 0.5,
    stroke: "#D9D9D9",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M5.117 7.088v3.828c0 .29.113.569.315.774s.476.32.761.32h8.614c.285 0 .559-.115.761-.32s.315-.484.315-.774V7.088zm3.947 2.735H6.911v-.73h2.153zm4.411.258a.6.6 0 0 1-.463-.215.61.61 0 0 1-.678.176.6.6 0 0 1-.29-.228.63.63 0 0 1 .29-.94.605.605 0 0 1 .678.176.61.61 0 0 1 .551-.21.61.61 0 0 1 .471.36.63.63 0 0 1-.264.806.6.6 0 0 1-.295.075M5.117 5.994v-.911c0-.29.113-.568.315-.773s.476-.32.761-.32h8.614c.285 0 .559.114.761.32.202.205.315.483.315.773v.911z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardIconSmall);
export default ForwardRef;